interface UpdateItem {
  date: string;
  tag: string;
  title: string;
  desc: string;
}

const updates: UpdateItem[] = [
  { date: '2026-07-28', tag: '新番上线', title: '《夏日幻梦》第三季第1话正式上线', desc: '人气恋爱喜剧第三季火热开播，每周五同步更新，全平台独家首播。' },
  { date: '2026-07-27', tag: '更新', title: '《剑与魔法》第142话已更新', desc: '冒险旅程进入新篇章，主角团面临前所未有的强敌挑战。' },
  { date: '2026-07-27', tag: '国漫', title: '《星域传说》第58话同步连载中', desc: '国产科幻巨制持续更新，画面品质全面升级，口碑爆棚。' },
  { date: '2026-07-26', tag: '韩漫', title: '《契约婚姻》番外篇独家上线51动漫', desc: '人气韩漫番外故事独家呈现，甜度升级引发追更热潮。' },
  { date: '2026-07-26', tag: '公告', title: '平台资源库突破20000+部', desc: '51动漫资源总量再创新高，涵盖日漫、韩漫、国漫全品类。' },
  { date: '2026-07-25', tag: '新番上线', title: '《暗夜追踪者》第二季全12话一次放出', desc: '悬疑推理类口碑之作第二季全集上线，下拉式连续阅读畅快追完。' },
  { date: '2026-07-25', tag: '更新', title: '《逆天邪神》第203话战斗高潮来袭', desc: '高燃打斗场面震撼呈现，画面张力拉满引爆讨论区。' },
  { date: '2026-07-24', tag: '活动', title: '暑期追番季专题活动正式开启', desc: '参与每日签到与阅读挑战，获取限定头像框与专属勋章。' },
  { date: '2026-07-24', tag: '国漫', title: '《长安幻夜》动画版定档8月上线', desc: '古风奇幻题材国漫新作，51动漫平台同步首播预约已开启。' },
];

function getTagStyle(tag: string): string {
  if (tag === '新番上线') return 'bg-accent-100 text-accent-700';
  if (tag === '活动') return 'bg-primary-100 text-primary-700';
  if (tag === '公告') return 'bg-secondary-100 text-secondary-700';
  return 'bg-background-200 text-foreground-600';
}

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            更新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            每日同步更新最新动漫资讯，新番上线、连载更新一手掌握
          </p>
        </div>

        <div className="space-y-0">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 py-4 border-b border-background-200/70 last:border-b-0 group cursor-pointer hover:bg-background-100/50 rounded-lg px-3 -mx-3 transition-colors"
            >
              <div className="flex items-center gap-3 sm:w-[320px] shrink-0">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${getTagStyle(item.tag)}`}>
                  {item.tag}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-1 line-clamp-1">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}